// extracted by mini-css-extract-plugin
export default {"container":"v1-z","list":"w1-z"};